import { polarClient } from '@polar-sh/better-auth';
import {
  emailOTPClient,
  lastLoginMethodClient,
  organizationClient,
} from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';

const baseURL = `${import.meta.env.VITE_BASE_API_URL}/auth`;

export const authClient = createAuthClient({
  baseURL,
  plugins: [organizationClient(), polarClient(), emailOTPClient(), lastLoginMethodClient()],
});

export type Session = typeof authClient.$Infer.Session;
export type User = typeof authClient.$Infer.Session.user;

export type Member = typeof authClient.$Infer.Member;
export type Invitation = typeof authClient.$Infer.Invitation;

export const { signUp, signOut } = authClient;
